'use strict';

const createNotification = require('eminence/components/notification');

const SELECTORS = {
    body: 'body',
    notificationMessage: '.js-notification-message, .error-messaging',
    notSelectedIcon: 'not-selected',
    selectedIcon: 'selected',
    wishlistIcon: '.js-wishlist-icon',
    productDetail: '.js-product-detail',
    productOption: '.product-option',
    productOptionSelected: '.options-select option:selected',
    productTile: '.product-tile',
    quickOrderProductTile: '.js-quickorder-product-tile',
    product: '.product',
    productLineItem: '.js-productlineitem',
    loginRedirectInput: '.js-login-redirect-url'
};

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 * @param {boolean} isAdding - if we are adding to wishlist
 */
function displayMessageAndChangeIcon(data, icon, isAdding) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'success';
        if (isAdding) {
            icon.removeClass(SELECTORS.notSelectedIcon).addClass(SELECTORS.selectedIcon);
        } else {
            icon.removeClass(SELECTORS.selectedIcon).addClass(SELECTORS.notSelectedIcon);
        }
    } else {
        status = 'danger';
    }

    if (data.msg) {
        createNotification($(SELECTORS.notificationMessage), data.msg, status);
    }

    setTimeout(function () {
        $(SELECTORS.notificationMessage).empty();
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $(SELECTORS.body).on('click', SELECTORS.wishlistIcon, function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var isAlreadyInWishlist = $(this).hasClass('active');
            var isAddingToWishlist = !isAlreadyInWishlist;

            var url = '';
            var method = '';
            var data = {};
            var pid = $(this).closest(SELECTORS.product).data('pid') || $(this).closest(SELECTORS.productTile).data('pid') ||  $(this).closest(SELECTORS.productDetail).data('pid') || $(this).closest(SELECTORS.quickOrderProductTile).data('pid') || $(this).closest(SELECTORS.productLineItem).data('pid');
            var icons = $('[data-pid="' + pid + '"]').find(SELECTORS.wishlistIcon).find('i');
            var optionId = $(this).closest(SELECTORS.productDetail).find(SELECTORS.productOption).attr('data-option-id');
            var optionVal = $(this).closest(SELECTORS.productDetail).find(SELECTORS.productOptionSelected).attr('data-value-id');
            var isMyAccount = $('div[data-is-my-account="true"]').length > 0;
            var dataType = isMyAccount ? 'html' : 'json';
            optionId = optionId || null;
            optionVal = optionVal || null;

            if (!isAlreadyInWishlist) {
                url = $(this).attr('href');
                if (!url || !pid) {
                    return;
                }
                method = 'post';
                data = {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal,
                    returnHtmlTemplate: isMyAccount
                };
            } else {
                if (isMyAccount) {
                    url = $(this).data('remove-ajax-url');
                } else {
                    url = $(this).data('remove-url');
                }
                method = 'get';
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: method,
                dataType: dataType,
                data: data,
                success: function (data) {
                    if (isMyAccount) {
                        $.spinner().stop();
                        icons.each(function () {
                            displayMessageAndChangeIcon({ success: true, msg: '' }, $(this), isAddingToWishlist);
                        });
                        $('[data-pid="' + pid + '"]').find(SELECTORS.wishlistIcon).toggleClass('active');
                        $('body').trigger('updateWishlistProducts', [ data ]);
                    } else {
                        if (data.error && !data.authenticated) {
                            $.spinner().stop();
                            var loginRedirectURL = $(SELECTORS.loginRedirectInput).val();
                            $('form.login').attr('action', loginRedirectURL);
                            $('#headerLogin').modal('show');
                        } else {
                            icons.each(function () {
                                displayMessageAndChangeIcon(data, $(this), isAddingToWishlist);
                            });
                            if ($('.js-cart-page').length) {
                                window.location.reload();
                            }
                            $('[data-pid="' + pid + '"]').find(SELECTORS.wishlistIcon).toggleClass('active');
                        }
                    }
                },
                error: function (err) {
                    console.log(err);
                    icons.each(function () {
                        displayMessageAndChangeIcon(err, $(this), isAddingToWishlist);
                    });
                }
            });
        });
    }
};
